import { createRoutine } from 'redux-saga-routines';

export const fetchReportTemplates = createRoutine('FETCH_REPORT_TEMPLATES');
export const createReportTemplate = createRoutine('CREATE_REPORT_TEMPLATE');
export const updateReportTemplate = createRoutine('UPDATE_REPORT_TEMPLATE');
export const deleteReportTemplate = createRoutine('DELETE_REPORT_TEMPLATE');
